import { create } from 'zustand'

export type FeedType = 'all' | 'videos' | 'premium' | 'reels'

interface FeedTypeStore {
    type: FeedType
    changeFeedType: (type: FeedType) => void
}
export const useFeedTypeStore = create<FeedTypeStore>()(set => ({
    type: 'all',
    changeFeedType: type => set(() => ({ type }))
}))
